import React from 'react'
import LoginOtpContainer from 'containers/LoginOtp'

const LoginOtp = (props) => {
    return (
        <LoginOtpContainer {...props}/>
    )
}

export default LoginOtp
